import { render, staticRenderFns } from "./CandidateDialog.vue?vue&type=template&id=a9f8797e&scoped=true&"
import script from "./CandidateDialog.vue?vue&type=script&lang=js&"
export * from "./CandidateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f8797e",
  null
  
)

export default component.exports